import moment from 'moment';

import { Colors, Variants } from '@/components/ui/types';
import { DEFAULT_KLASS_DURATION_IN_MINUTES } from '@/constants';
import ScheduledLesson from '@/models/ScheduledLesson';

export enum ScheduledLessonStatusEnum {
  CONCLUDED = 'CONCLUDED',
  PENDING = 'PENDING',
  SCHEDULED = 'SCHEDULED',
}

export const getScheduledLessonStatus = (
  { datetime, hasDone }: Pick<ScheduledLesson, 'datetime' | 'hasDone'>,
  klassDuration?: number,
) => {
  if (hasDone) return ScheduledLessonStatusEnum.CONCLUDED;

  const endTime = moment(datetime).add(
    klassDuration || DEFAULT_KLASS_DURATION_IN_MINUTES,
    'minutes',
  );

  if (endTime.isBefore(moment())) return ScheduledLessonStatusEnum.PENDING;
  return ScheduledLessonStatusEnum.SCHEDULED;
};

export const scheduledLessonStatusColors: Record<
  ScheduledLessonStatusEnum,
  Colors
> = {
  [ScheduledLessonStatusEnum.CONCLUDED]: 'success',
  [ScheduledLessonStatusEnum.PENDING]: 'warning',
  [ScheduledLessonStatusEnum.SCHEDULED]: 'neutral',
};

export const scheduledLessonStatusVariants: Record<
  ScheduledLessonStatusEnum,
  Variants
> = {
  [ScheduledLessonStatusEnum.CONCLUDED]: 'soft',
  [ScheduledLessonStatusEnum.PENDING]: 'soft',
  [ScheduledLessonStatusEnum.SCHEDULED]: 'dash',
};
